var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrawerVoucherIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x9D\xB4\xEC\x9A\xA9\xEA\xB6\x8C icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x9D\xB4\xEC\x9A\xA9\xEA\xB6\x8C icon_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.2219 20.2219C20.8906 19.5531 21.9676 19.5531 22.6364 20.2219L24.6079 18.2503C24.9553 17.9029 24.9553 17.347 24.6079 17.0083L13.3865 5.78693C13.0391 5.43951 12.4833 5.43951 12.1445 5.78693L10.173 7.75848C10.8418 8.42725 10.8418 9.50422 10.173 10.173C9.50422 10.8418 8.42725 10.8418 7.75848 10.173L5.78693 12.1445C5.43951 12.492 5.43951 13.0478 5.78693 13.3865L17.0083 24.6079C17.3557 24.9553 17.9116 24.9553 18.2503 24.6079L20.2219 22.6364C19.5531 21.9676 19.5531 20.8906 20.2219 20.2219Z",
    fill: "white",
    stroke: "#E60063",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.2107 13.0856C16.2295 13.0856 17.0576 13.9136 17.0576 14.9325V16.7794H15.2107C14.1918 16.7794 13.3638 15.9513 13.3638 14.9325C13.3638 13.9136 14.1918 13.0856 15.2107 13.0856Z",
    stroke: "#E60063",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerVoucherIcon);
export default __webpack_public_path__ + "static/media/drawer_voucher_icon.e1302b46126cc12689c5fd7b3da5c93f.svg";
export { ForwardRef as ReactComponent };